import React from 'react';
import styled from 'styled-components';

import { Html } from '../services/products';
import PreloaderGraphic from './PreloaderGraphic';

const Price = styled.span`
  .price {
    font-size: inherit;
  }

  .undefined-price {
    font-weight: bold;
  }

  .comparative-list-price .undefined-price {
    text-decoration: line-through; // TODO: remove once responsive-global.less is pulled in when running in local dev
    font-weight: normal;
  }

  .discount-price {
    color: rgb(
      238,
      2,
      133
    ); // TODO: remove once responsive-global.less is pulled in when running in local dev
  }

  // Actually the base price
  .discount {
    color: rgb(145, 150, 153);
  }
`;

export const PriceLoader = () => (
  <div style={{ height: 25, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
    <PreloaderGraphic />
  </div>
);

export const LoadablePrice = ({ price }: { price?: Html }) =>
  price !== undefined ? <Price dangerouslySetInnerHTML={price} /> : <PriceLoader />;
